import React, { useContext } from "react";
import { Edit } from "react-feather";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { BUTTON, PARIVAR_SABHA } from "../../constant";
import LoaderContext from "../../context/LoaderContext/LoaderContext";
import ParivarSabhaContext from "../../context/ParivarSabhaMasterContext/ParivarSabhaMasterContext";

const OrganizationAddModel = (props) => {
  const { onSubmit, closeModel } = props;
  const {
    modal,
    togglesubmit,
    link,
    setLink,
    name,
    setName,
    date,
    setDate,
    details,
    setDetails,
  } = useContext(ParivarSabhaContext);

  const { loaderShow } = useContext(LoaderContext);

  return (
    <>
      <Modal size="xl" isOpen={modal}>
        <ModalHeader toggle={() => closeModel()}>
          {togglesubmit ? (
            <span>{PARIVAR_SABHA.ADD_PARIVAR_SABHA}</span>
          ) : (
            <span>
              {PARIVAR_SABHA.EDIT_PARIVAR_SABHA} <span> </span>{" "}
              <Edit
                style={{ width: "50px", height: "20px", color: "#7366ff" }}
              />
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          {/* <LoaderResponse /> */}
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <h5> {PARIVAR_SABHA.PARIVAR_SABHA_DETAILS}</h5>
                </CardHeader>
                <CardBody>
                  <Form
                    className="needs-validation"
                    onSubmit={(e) => onSubmit(e)}
                  >
                    <Row>
                      <Col md="4 mb-4">
                        <Label htmlFor="validationCustom14">
                          {PARIVAR_SABHA.LINK}
                        </Label>
                        <Input
                          className="form-control"
                          name="name"
                          id="validationCustom14"
                          type="url"
                          placeholder="Link"
                          onChange={(e) => setLink(e.target.value)}
                          value={link}
                        />
                        <div className="invalid-feedback">
                          {"Please provide a valid Admin Name."}
                        </div>
                      </Col>
                      <Col md="4 mb-4">
                        <Label htmlFor="validationCustom14">
                          {PARIVAR_SABHA.NAME}
                        </Label>
                        <Input
                          className="form-control"
                          name="name"
                          id="validationCustom14"
                          type="text"
                          placeholder="Name"
                          onChange={(e) => setName(e.target.value)}
                          value={name}
                        />
                        <div className="invalid-feedback">
                          {"Please provide a valid Admin Name."}
                        </div>
                      </Col>
                      <Col md="4 mb-4">
                        <Label htmlFor="validationCustom14">
                          {PARIVAR_SABHA.DATE}
                        </Label>
                        <Input
                          className="form-control"
                          name="name"
                          id="validationCustom14"
                          type="date"
                          placeholder="Date"
                          onChange={(e) => setDate(e.target.value)}
                          value={date}
                        />
                        <div className="invalid-feedback">
                          {"Please provide a valid Admin Name."}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom14">
                          {PARIVAR_SABHA.DETAILS}
                        </Label>
                        <textarea
                          className="form-control"
                          name="details"
                          id="detailss"
                          cols="30"
                          rows="5"
                          onChange={(e) => setDetails(e.target.value)}
                          value={details}
                        />
                      </Col>
                    </Row>
                    <Row style={{ paddingTop: "30px" }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={loaderShow === true}
                      >
                        {BUTTON.SUBMIT}
                      </button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default OrganizationAddModel;
